import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { apiRequest } from "../../lib/request"

// AI Asset Manager / library: DELETE /api/v1/media?mediaIds=1784
// Post-attached (computer upload) deletes: use postMediaDeleteSlice.deletePostMedia
export const deleteMedia = createAsyncThunk(
  "mediaDelete/deleteMedia",
  async ({ mediaId, mediaIds }, { rejectWithValue }) => {
    try {

      // Handle both single ID and array of IDs
      let idsArray = mediaIds || []
      if (mediaId) {
        idsArray = [mediaId]
      }

      if (!idsArray || idsArray.length === 0) {
        console.error("No media IDs provided for deletion")
        throw new Error("Media ID is required")
      }

      const url = `/media?${idsArray.map((id) => `mediaIds=${encodeURIComponent(id)}`).join("&")}`

      const response = await apiRequest(url, { method: "DELETE" })

      return { mediaIds: idsArray }
    } catch (error) {
      console.error("Delete media API error:", error)
      return rejectWithValue(error?.message || error?.error || "Failed to delete media")
    }
  },
)

const mediaDeleteSlice = createSlice({
  name: "mediaDelete",
  initialState: {
    status: "idle",
    error: null,
    deletedMediaId: null,
  },
  reducers: {
    resetDeleteState: (state) => {
      state.status = "idle"
      state.error = null
      state.deletedMediaId = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteMedia.pending, (state) => {
        state.status = "loading"
      })
      .addCase(deleteMedia.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.deletedMediaId = action.payload.mediaIds[0]
      })
      .addCase(deleteMedia.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const { resetDeleteState } = mediaDeleteSlice.actions
export default mediaDeleteSlice.reducer
